export const anyGetter = (state, getters, rootState) => {
  return null;
};
